import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { IDatabaseInfo } from '../../ts/models/IDatabaseInfo';
import { GetDatabasesRequest } from '../../ts/ServerApi/requests/GetDatabasesRequest';
import { IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';


class DatabasesWithCrassResource implements IListResource<IDatabaseInfo> {

  private listFetcher: IListFetcher<IDatabaseInfo> = new WebClientListResourceFetcher(GetDatabasesRequest, ServerApiMapper.databasesUsingCrass);

  public all(): ResourceQuery<IDatabaseInfo> {
    return new ResourceQuery(this.listFetcher);
  }

}

export const DatabasesWithCrass = new DatabasesWithCrassResource();
export type DatabasesWithCrass = typeof DatabasesWithCrass;
